import { LearnTabContent } from "../home/LearnTabContent";

const SciencePage = () => {
  return (
    <div className="flex-1 overflow-y-auto">
      <div className="max-w-5xl mx-auto px-6 md:px-8 py-6">
        <LearnTabContent />
      </div>
    </div>
  );
};

export default SciencePage;
